import { render } from "./multiColorCard.vue?vue&type=template&id=d5b0f902&scoped=true"
import script from "./multiColorCard.vue?vue&type=script&lang=js"
export * from "./multiColorCard.vue?vue&type=script&lang=js"

import "./multiColorCard.vue?vue&type=style&index=0&id=d5b0f902&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b0f902"]])

export default __exports__